import type { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'inline-flex',
    gap: 16,
    padding: '12px 24px',
    alignItems: 'center',
    background: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.9)' : 'rgba(0, 0, 0, 0.85)',
    color: theme.palette.mode === 'dark' ? theme.palette.ava.dark1 : theme.palette.ava.white,
    fontWeight: 400,
    fontSize: 16,
    borderRadius: 100,
    boxShadow:
      theme.palette.mode === 'dark' ? '0px 4px 16px rgba(255, 255, 255, 0.1)' : '0px 4px 16px rgba(0, 0, 0, 0.15)',
    backdropFilter: 'blur(8px)',
  },
  desktop: {
    padding: '4px 4px 4px 8px',
    gap: 8,
    borderRadius: 6,
    color: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)',
    fontWeight: 600,
    fontSize: 14,
  },
}));

type Props = {
  children: React.ReactNode;
  desktop: boolean;
};

export const ConvoV2NotificationContent = React.memo(({ children, desktop }: Props) => {
  const classes = useStyles();

  return <Box className={classNames(classes.root, { [classes.desktop]: desktop })}>{children}</Box>;
});
